import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row awardSlider" };
const _hoisted_2 = {
    key: 0,
    class: "col-12 px-sm-3 pb-45 px-0"
};
const _hoisted_3 = { class: "d-flex fill-height justify-center align-center h-100 align-items-center justify-content-center" };
const _hoisted_4 = ["href", "title"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "col-md-7 col-12 px-0" };
const _hoisted_7 = {
    class: "clickLogos w-100",
    style: { "display": "flex", "flex-wrap": "wrap", "justify-content": "space-around" }
};
const _hoisted_8 = ["href", "title"];
const _hoisted_9 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_carousel_item = _resolveComponent("v-carousel-item");
    const _component_v_carousel = _resolveComponent("v-carousel");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("p", { class: "h2-responsive mt-4 text-center fc_brand_deep_blue mb-3 p-2" }, "Unsere Auszeichnungen:", -1)),
                _createVNode(_component_v_card, {
                    class: "mx-auto",
                    style: { "background-color": "inherit" },
                    flat: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_carousel, {
                            continuous: true,
                            cycle: true,
                            "show-arrows": false,
                            "hide-delimiters": false,
                            "hide-delimiter-background": "",
                            "delimiter-icon": "icon-circle",
                            height: "244",
                            class: "progressButtonsChanged"
                        }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
                                    return (_openBlock(), _createBlock(_component_v_carousel_item, { key: index }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createElementVNode("a", {
                                                    href: logo.link,
                                                    title: logo.title,
                                                    rel: "nofollow noopener noreferrer",
                                                    target: "_blank",
                                                    class: "mb-5"
                                                }, [
                                                    _createElementVNode("img", {
                                                        src: _ctx.optimizeImage(logo.path, 300),
                                                        alt: logo.alt,
                                                        style: { "height": "144px", "width": "100%", "object-fit": "contain" }
                                                    }, null, 8, _hoisted_5)
                                                ], 8, _hoisted_4)
                                            ])
                                        ]),
                                        _: 2
                                    }, 1024));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", {
                    class: "col-md-5 col-12",
                    style: { "display": "flex", "align-items": "center" }
                }, [
                    _createElementVNode("h2", {
                        class: "h2-responsive d-lg-inline-block d-block mr-3 mb-md-0 mb-3",
                        style: { "word-break": "normal", "hyphens": "none" }
                    }, " Unsere Auszeichnungen: ")
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
                            return (_openBlock(), _createElementBlock("a", {
                                key: index,
                                href: logo.link,
                                target: "_blank",
                                rel: "nofollow noopener noreferrer",
                                title: logo.title
                            }, [
                                _createElementVNode("img", {
                                    class: "m-2",
                                    src: logo.path,
                                    alt: logo.alt,
                                    style: { "height": "90px", "width": "90px", "object-fit": "contain" }
                                }, null, 8, _hoisted_9)
                            ], 8, _hoisted_8));
                        }), 128))
                    ])
                ])
            ], 64))
    ]));
}
